import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { applyLatestSearchCriteria, clearLatestSearchCriteria } from "domains/knowledgeFeed/actions";
import { getLatestSearchCriteria } from "domains/knowledgeFeed/selectors";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicLatestFilterModal = () => {
  const dispatch = useDispatch();
  const searchCriteria = useSelector(getLatestSearchCriteria);
  const filters = useSelector(getTopicFilters("latest"));

  useEffect(() => {
    dispatch(applyLatestSearchCriteria());
  }, [dispatch]);

  return (
    <TopicFilterModal
      dataTestId="latest-search-filters-sidebar"
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyLatestSearchCriteria(payload))}
      handleClear={() => dispatch(clearLatestSearchCriteria())}
      searchCriteria={searchCriteria}
    />
  );
};
